import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import close from '../../app-main-content/icons/close.svg'
import but_ON from '../../app-main-content/icons/but_ON.svg'
import but_OFF from '../../app-main-content/icons/but_OFF.svg'
import { getPlaylistsSearchResults} from '../../actions/AdminPlaylistsActions';
import { deleteVideoFromPlaylistForAdminFromVideoPage, addVideoToPlaylistForAdmin  } from '../../actions/videoActions'



const AddToPlaylist = (props) => {

    const dispatch = useDispatch()

    const { adminPlaylists, loadingAdminPlaylists } = useSelector(state=>state.adminPlaylists)

    const handleScroll = event => {
        const {scrollTop, clientHeight, scrollHeight} = event.currentTarget;
        let h
        h = Math.round(scrollHeight - scrollTop)
        if(h === clientHeight || h+1 === clientHeight || h-1 === clientHeight){
          setPage(prev => prev + 1)
        }
      }

    // const [val, setVal] = useState("")

    const [page, setPage] = useState(1)

    const [searchValue, setSearchValue] = useState("")


    useEffect(()=>{
        if(page > 1){
            if (searchValue && searchValue.length > 0){
                dispatch(getPlaylistsSearchResults(searchValue, page, props.video.id, 2))
            } else {
                dispatch(getPlaylistsSearchResults(" ", page, props.video.id, 2))
            }
        }
    }, [page])

    useEffect(()=>{
        if (searchValue && searchValue.length > 0){
            dispatch(getPlaylistsSearchResults(searchValue, page, props.video.id, 1))
        } else {
            dispatch(getPlaylistsSearchResults(" ", page, props.video.id, 1))
        }
    }, [props.video.id])

    useEffect(()=>{
        const identifer = setTimeout(()=>{
            if (searchValue && searchValue.length > 0){
                dispatch(getPlaylistsSearchResults(searchValue, 1, props.video.id, 1))
            } 
        }, 500)  
    
        return () => { clearTimeout(identifer) }
    
      },[searchValue])

    const clickHandler = (playlist) => {
        if(!props.video.playlists.includes(playlist.id) ){
            dispatch(addVideoToPlaylistForAdmin([props.video.id], playlist))
        }
        else  {
            dispatch(deleteVideoFromPlaylistForAdminFromVideoPage(props.video.id, playlist.id))
        }
      }


    return (
        <div style={{width:"300px"}}>
            <div className = 'w-100 bg-secondary d-flex justify-content-between py-2 px-2 rounded-top'>
                <div className='text-white px-3' style={{fontWeight: 500}}>Add to Playlist</div>
                <img src={close} alt = "close" role="button" onClick={()=>props.setIsActive(false)}/>
            </div>
            <div className = "px-2 position-relative d-flex justify-content-end bg-white pt-2 align-items-center" 
                style={{userSelect:"none", height:"2.5rem"}} 
                >
                <div className="w-100 h-100 bg-light d-flex py-2 me-3 rounded border border-info"
                >
                    <input
                        type="text"
                        className="w-100 fs-5 border-0 bg-light text-secondary search-input px-2"
                        placeholder="Write or Select"
                        onChange={(e)=>{
                            setSearchValue(e.target.value); 
                            setPage(1);
                            // setVal(e.target.value)
                        }}
                        value={searchValue}
                    />
                </div>
            </div>
            <div className='col-12 p-3 rounded-bottom' style={{background:"#F3F9FF"}}>
                <div className = "w-100 addToplaylist-list-wrapper"
                    onScroll = {handleScroll}
                >
                    <div>
                        {
                            loadingAdminPlaylists && page ===1 ?
                            <div className='text-center text-secondary fw-bold py-3'>Loading...</div> :
                            adminPlaylists && adminPlaylists.length ?
                            adminPlaylists.map((playlist, index)=>(
                                <div className='d-flex' key = {index}
                                    onClick={()=>clickHandler(playlist)}>
                                    {
                                        props.video.playlists && props.video.playlists.includes(playlist.id) ?
                                        <img src = {but_ON} alt = "" /> : 
                                        <img src = {but_OFF} alt = ""/> 
                                    }
                                    <div key = {index}
                                        role = "button"
                                        className='text-secondary py-1 fw-bold ps-2'>
                                        {playlist.title}
                                    </div>
                                </div>
                            )) : ""
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddToPlaylist;